import React, {useEffect, useRef} from "react";
import {getUser, login} from './authService';


export function ProtectedRoute({children}) {
    const [user, setUser] = React.useState(null);
    const redirectTriggered = useRef(false);

    useEffect(() => {
        getUser().then((authenticatedUser) => setUser(authenticatedUser || false));
    }, []);

    // Si pas d'utilisateur, déclencher directement la redirection OIDC
    useEffect(() => {
        if (user === false && !redirectTriggered.current) {
            redirectTriggered.current = true;
            login();
        }
    }, [user]);

    if (user === null) return <div>Chargement...</div>;

    // Pendant la redirection, on affiche un écran neutre
    if (user === false) return <div>Redirection vers l'authentification…</div>;

    return children;
};

export default ProtectedRoute;
